import React from 'react';
import { ArrowLeft, ArrowUp, ArrowRight, ArrowDown } from '@tpr/icons';
export var ArrowIcon = function (_a) {
    var pointsTo = _a.pointsTo, size = _a.size, _b = _a.fill, fill = _b === void 0 ? 'primary.3' : _b;
    switch (pointsTo) {
        case 'left':
            return React.createElement(ArrowLeft, { cfg: { fill: fill }, width: size });
        case 'up':
            return React.createElement(ArrowUp, { cfg: { fill: fill }, width: size });
        case 'right':
            return React.createElement(ArrowRight, { cfg: { fill: fill }, width: size });
        case 'down':
            return React.createElement(ArrowDown, { cfg: { fill: fill }, width: size });
        default:
            return React.createElement(ArrowLeft, { cfg: { fill: fill }, width: size });
    }
};
//# sourceMappingURL=icons.js.map